import React, { useContext, useEffect, useRef, useState } from 'react'
import drapeauMaroc from '../../assets/drapeauxCarres/flagMaroc.svg'
import drapeauSenegal from '../../assets/drapeauxCarres/drapeauSenegal.svg'
import flagTunisie from '../../assets/drapeauxCarres/drapeauTunisie.svg'
import drapeauBangladesh from '../../assets/drapeauxCarres/FlagBangladesh.svg'
import drapeauTurkey from '../../assets/drapeauxCarres/FlagTurkey.svg'
import drapeauNigeria from '../../assets/drapeauxCarres/nigeria.svg'
import drapeauKenya from '../../assets/drapeauxCarres/kenya.svg'
import drapeauPakistan from '../../assets/drapeauxCarres/FlagPakistan.svg'
import ArrowDown from '../../assets/iconTsx/DropDown'
import { Philippines } from 'assets/drapeauxCarres'
import { getCurrenciesWithServices } from 'helpers/api'
import BeneficiaryContext from 'contexts/beneficiaryContext'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'

interface Props {
  dinarValue?: number
  handleDinarChange?: any
  setValuePays?: any
  valuePays?: any
  number: number
  service?: string
  setPaysCode:(val:string)=>void
}

// OPTIONS GLOBAL (hors du composant)
const OPTIONS = [
  { icon: flagTunisie, value: 'TND',label:'Tunisie', code:'TUN'},

  { icon: drapeauSenegal, value: 'XOF', label:'Sénégal',  code: 'SEN' },
  { icon: drapeauMaroc, value: 'MAD', label:'Maroc',  code: 'MAR', nouveauService:['isBank']},
  { icon: drapeauPakistan, value: 'PKR', label:'Pakistan',  code: 'PAK', nouveauService: ['isCash','isBank', 'isWallet'] },
  { icon: drapeauBangladesh, value: 'BDT', label:'Bangladesh',  code: 'BGD', nouveauService: ['isCash'] },
  { icon: drapeauTurkey, value: 'TRY', label:'Turquie',  code: 'TUR', nouveauService: ['isBank'] },
  { icon: drapeauNigeria, value: 'NGN', label:'Nigeria',  code: 'NGA', nouveauService: ['isBank'] },
  { icon: drapeauKenya, value: 'KES', label:'Kenya',  code: 'KEN', nouveauService: ['isBank', 'isWallet'] },
  { icon: Philippines, value: 'PHP', label:'Philippines',  code: 'PHL', nouveauService: ['isBank', 'isWallet'] },
]

const ContainerTransfer: React.FC<Props> = ({
  dinarValue,
  handleDinarChange,
  setValuePays,
  valuePays,
  number,
  service,
  setPaysCode
}) => {
  const { beneficiaries } = useContext(BeneficiaryContext)
  const { TransferData, setTransferData } = useContext(transferBeneficiaryContext)

  const [currencies, setCurrencies] = useState<any[]>([]) // Toutes les devises
  const [listOption, setListOption] = useState<any[]>([]) // Options filtrées selon le service
  const [isOpen, setIsOpen] = useState(false)

  const dropDownRef = useRef<HTMLDivElement>(null)
  const scrollAreaRef = useRef<HTMLDivElement>(null)
  const scrollThumbRef = useRef<HTMLDivElement>(null)

  // Charger l'API une seule fois
  useEffect(() => {
    const fetchCurrencies = async () => {
      const data = await getCurrenciesWithServices()
      setCurrencies(data)
    }
    fetchCurrencies()
  }, [])

  useEffect(()=>{
    const data=OPTIONS.find((item:any)=>item.value===valuePays.value)
    if(data)
     setPaysCode(data.code)
  },[valuePays.value, setPaysCode])

  // Filtrer localement selon le service
  useEffect(() => {
    if (!service || !currencies.length) return

    const filterList = currencies.filter((item: any) => item[service] === true)

    const options = OPTIONS.filter(option => filterList.some(currency => currency.code === option.value)  )

    setListOption(options)
   
    // Vérifier si la devise sélectionnée est dans la liste
    const isPayDestination = filterList.some(item => item.code === valuePays?.value)
    if (!isPayDestination) {
      if( service === 'isWallet'){
      setValuePays?.({ value: 'XOF' })
      }else
      setValuePays?.({ value: 'TND' })
    }
  }, [service, currencies])
  
  // Gestion du select
  const handleSelectChange = (selectedValue: string, paysCode:string) => {
    setValuePays?.({ value: selectedValue })
    setPaysCode(paysCode)
    
    // if (TransferData?.valuePays !== selectedValue) setTransferData?.(null)
     if (TransferData?.valuePays !== selectedValue) setTransferData?.(null)
    
  }

  // Selected option avec fallback pour éviter le flash
const selectedOption = OPTIONS.find((item) => item.value === valuePays?.value) 

  // Click outside pour fermer le dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])


  // Scrollbar custom
  useEffect(() => {
    const content = scrollAreaRef.current
    const thumb = scrollThumbRef.current
    if (!content || !thumb) return

    const updateThumb = () => {
      const ratio = content.scrollTop / (content.scrollHeight - content.clientHeight)
      thumb.style.transform = `translateY(${ratio * 100}%)`
    }

    content.addEventListener('scroll', updateThumb)
    return () => content.removeEventListener('scroll', updateThumb)
  }, [isOpen])


  return (
    <div className="flex flex-col w-full mt-4 h-[130px] sm:h-[120px] font-roboto font-medium">
      <h3 className="h3">
        Montant à recevoir <span className="text-[#FF0000]">*</span>
      </h3>

      <div
        className="relative flex items-center gap-2 pl-4 border focus-within:border-[#5754E5] border-[#AEB6FB] w-full rounded-[16px] h-[56px] mt-[12px] cursor-pointer"
        ref={dropDownRef}
      >
        {/* Select */}
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="bg-[#F1F1FF] flex-shrink-0 pl-2 flex items-center justify-center gap-1 h-[32px] rounded-[8px]"
        >
          {selectedOption &&<img
            src={selectedOption.icon || flagTunisie}
            alt={`Pays de destination: ${selectedOption.value}`}
            className="w-[27px] h-[18px]"
          />}
          <span className="text-[#8F8FCD]">{selectedOption?.value || ''}</span>
          <ArrowDown styleCssImage={`${isOpen ? 'fill-[#5754E5] rotate-180' : 'fill-[#AEB6FB]'}`} />
        </div>

        {/* Input */}
        <input
          type="text"
          placeholder="valeur en dinar"
          value={typeof dinarValue === 'number' && !isNaN(dinarValue) ? dinarValue : ''}
          onChange={e => handleDinarChange(parseFloat(e.target.value))}
          className="flex-1 min-w-0 outline-none text-[18px] pl-2 rounded-xl h-[50px] text-[#35258B] focus:text-[#5754E5] placeholder:text-[#D1D1FF]"
        />

        {/* Dropdown */}
        {isOpen && (
           <div className="absolute top-full left-0 mt-1 z-10 w-full rounded-lg bg-white shadow-[0px_6px_10px_rgba(87,84,229,0.15)]">
          <div
            ref={scrollAreaRef}
            className=" py-2 flex  flex-col  left-0 z-10 w-full scrollbar-hide overflow-y-scroll max-h-[150px]"
          >
            {listOption.map((item: any, index: number) => (
              <div
                key={index}
                onClick={() => {
                  if(item.bientot && service==='isWallet') return
                  { handleSelectChange(item.value, item.code)
                  setIsOpen(false)}
                }}
                className={`${
                  item.value === valuePays?.value ? 'text-[#5754E5] bg-[#F1F1FF]' : 'text-[#35258B]'}
                   flex  min-h-[56px] items-center justify-between px-4  ,
                   ${item.bientot && service==='isWallet' ? 'opacity-30 text-[#5754E5]  cursor-not-allowed': 'hover:text-[#4D36CC] cursor-pointer'}`}
              >
                <div className='flex items-center gap-2'>
                <img className="w-[27px] h-[18px]" src={item.icon} alt={item.value} />
                <div className="text-[18px]">{item.label}</div>
                </div>
                {item.nouveauService?.includes(service) && <div className='bg-[#EC1C24] rounded-[3px] w-[50px] py-1 text-center font-semibold text-white font-roboto text-[8px]  '> Nouveau</div>}
              </div>
            ))}
          </div>
            {/* Scrollbar overlay */}
            {listOption.length >2 &&
            <div className="absolute top-2 bottom-2 right-2 w-[8px] bg-[#E2E2FB] rounded-full ">
              <div ref={scrollThumbRef} className="w-full bg-[#AEB6FB] rounded-full" style={{ height: '50%' }} />
            </div>
        }
          </div>
        )}
      </div>
    </div>
  )
}

export default ContainerTransfer
